import "./CookiesMessage.styl";

import React from "react";
import classNames from "classnames";
import { Link } from "react-router";
import {
  FormattedMessage,
  defineMessages,
  injectIntl,
  intlShape
} from "react-intl";

class CookiesMessage extends React.Component {
  constructor() {
    super();

    this.state = {
      isActive: false
    };
    this.closeCookie = this.closeCookie.bind(this);
  }

  componentDidMount() {
    if (localStorage) {
      if (!window.localStorage.cookiesMessage) {
        this.setState({
          isActive: true
        });
      }
    }
  }

  closeCookie() {
    this.setState({
      isActive: false
    });

    if (localStorage) {
      window.localStorage.setItem("cookiesMessage", true);
    }
  }

  render() {
    const { intl } = this.props;

    return (
      <div
        className={classNames("cookies-message", {
          active: this.state.isActive
        })}
      >
        <span className="close-message" onClick={this.closeCookie}>
          {"[Zamknij]"}
        </span>{" "}
        <span>
          {
            "Strona korzysta z plików cookie w celu realizacji usług zgodnie z"
          }{" "}
          <Link target="_blank" to="/polityka-prywatnosci">
            {" "}
            {"Polityką prywatności"}{" "}
          </Link>{" "}
          {
            ". Możesz określić warunki przechowywania lub dostępu do cookie w Twojej przeglądarce."
          }
        </span>
      </div>
    );
  }
}

CookiesMessage = injectIntl(CookiesMessage);

export default CookiesMessage;



/** WEBPACK FOOTER **
 ** ./src/browser/components/CookiesMessage/CookiesMessage.js
 **/